// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
  ACADEMICDASHBOARD: '/academicdashboard',
  STUDENTDASHBOARD: '/studentdashboard',
  PARENTDASHBOARD: '/parentdashboard',
  HEIGHTSTUDENTDASHBOARD: '/heightstudentdashboard',
  OUTSIDERDASHBOARD: '/outsiderdashboard',
  GUESTDASHBOARD: '/guestdashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  // register: '/register',
  guestRegister: '/guest-register',
  courseRegister: '/course/register',
  page403: '/403',
  page404: '/404',
  icicipayment: '/payform',
  successpayment: '/successpayment',
  iciciexampayment: '/payformexam',
  studentcreate: '/studentcreate',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/hjxMnGUJCjY7pX8lQbS7kn/%5BPreview%5D-Minimal-Web.v5.4.0?type=design&node-id=0-1&mode=design&t=2fxnS70DuiTLGzND-0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  thelogin: '/the-login',
  submit: '/submit',
  studentexamination: {
    test: (id) => `/studentexamination/${id}/test`,
    instruction: (id) => `/studentexamination/instruction/${id}`,
  },
  height_submit: '/height-submit',
  height_student_examination: {
    test: (id) => `/student/height/examination/${id}/test`,
    instruction: (id) => `/student/height/examination/instruction/${id}`,
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
    verifyEmail: '/verify-email',
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },

  heightstudentdashboard: {
    root: ROOTS.HEIGHTSTUDENTDASHBOARD,
    downloads: `${ROOTS.HEIGHTSTUDENTDASHBOARD}/downloads`,
    admitcard: `${ROOTS.HEIGHTSTUDENTDASHBOARD}/admitcard`,
    studentexamination: {
      root: `${ROOTS.HEIGHTSTUDENTDASHBOARD}/studentexamination`,
    },
    examinationresult: {
      root: `${ROOTS.HEIGHTSTUDENTDASHBOARD}/examinationresult`,
      profile: (id) => `${ROOTS.HEIGHTSTUDENTDASHBOARD}/examinationresult/${id}/profile`,
    },
  },

  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    hostelmaster: `${ROOTS.DASHBOARD}/hostelmaster`,
    tax: `${ROOTS.DASHBOARD}/tax`,
    center: `${ROOTS.DASHBOARD}/center`,
    center_profile: (id) => `${ROOTS.DASHBOARD}/center/${id}/profile`,
    school: `${ROOTS.DASHBOARD}/school`,
    school_profile: (id) => `${ROOTS.DASHBOARD}/school/${id}/profile`,
    tag: `${ROOTS.DASHBOARD}/tag`,
    organization: `${ROOTS.DASHBOARD}/organization`,
    subject: `${ROOTS.DASHBOARD}/subject`,
    session: `${ROOTS.DASHBOARD}/session`,
    classes: `${ROOTS.DASHBOARD}/classes`,
    target: `${ROOTS.DASHBOARD}/target`,
    discount: `${ROOTS.DASHBOARD}/discount`,
    bank: `${ROOTS.DASHBOARD}/bank`,
    // pattern: `${ROOTS.DASHBOARD}/pattern`,
    attendance: `${ROOTS.DASHBOARD}/attendance`,
    feeparent: `${ROOTS.DASHBOARD}/feeparent`,
    // feestudent: `${ROOTS.DASHBOARD}/feestudent`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      academicdashboard: `${ROOTS.ACADEMICDASHBOARD}`,
      nonacademicdashboard: `${ROOTS.DASHBOARD}/nonacademicdashboard`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    role: `${ROOTS.DASHBOARD}/roles`,
    dat: `${ROOTS.DASHBOARD}/dat`,
    question_difficulty_configuration: `${ROOTS.DASHBOARD}/question-difficulty-configuration`,
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      logs: `${ROOTS.DASHBOARD}/user/logs`,
      new1: `${ROOTS.DASHBOARD}/user/new-non-academic`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: (id) => `${ROOTS.DASHBOARD}/user/${id}/profile/academic`,
      nonprofile: (id) => `${ROOTS.DASHBOARD}/user/${id}/profile/nonacademic`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      edit_nonacademic: (id) => `${ROOTS.DASHBOARD}/user/non-academic/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },

    },
    template: `${ROOTS.DASHBOARD}/template`,
    sms_template: `${ROOTS.DASHBOARD}/sms-template`,
    email_template: `${ROOTS.DASHBOARD}/communication/email-template`,
    whatsapp_template: `${ROOTS.DASHBOARD}/communication/whatsapp-template`,
    communication: {
      root: `${ROOTS.DASHBOARD}/communication`,
      create: `${ROOTS.DASHBOARD}/communication/create`,
      logs: `${ROOTS.DASHBOARD}/communication-logs`,
      sender_credentials: `${ROOTS.DASHBOARD}/communication/sender-credentials`,
      sms_template: `${ROOTS.DASHBOARD}/sms-template`,
      email_template: `${ROOTS.DASHBOARD}/communication/email-template`,
      whatsapp_template: `${ROOTS.DASHBOARD}/communication/whatsapp-template`,
      sms_category: `${ROOTS.DASHBOARD}/communication/sms-category`,
      linked_template: `${ROOTS.DASHBOARD}/communication/linked-template`,
    },
    linked_template: `${ROOTS.DASHBOARD}/communication/linked-template`,

    create_communication: `${ROOTS.DASHBOARD}/communication/create`,
    communication_logs: `${ROOTS.DASHBOARD}/communication-logs`,
    login_logs: `${ROOTS.DASHBOARD}/login-logs`,
    payment_amount_update_logs: `${ROOTS.DASHBOARD}/payment-amount-update-logs`,
    student: {
      root: `${ROOTS.DASHBOARD}/student`,
      new: `${ROOTS.DASHBOARD}/student/new`,
      newWithoutSteps: `${ROOTS.DASHBOARD}/student/new-without-steps`,
      logs: `${ROOTS.DASHBOARD}/student/logs`,
      list: `${ROOTS.DASHBOARD}/student/list`,
      cards: `${ROOTS.DASHBOARD}/student/cards`,
      profile: (id) => `${ROOTS.DASHBOARD}/student/${id}/profile`,
      account: `${ROOTS.DASHBOARD}/student/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/student/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
      register: `${ROOTS.DASHBOARD}/student/register`,
      bulkupload: `${ROOTS.DASHBOARD}/student/bulkupload`,
    },


    timetable: {
      root: `${ROOTS.DASHBOARD}/timetable`,
      list: `${ROOTS.DASHBOARD}/timetable/list`,
      slots: `${ROOTS.DASHBOARD}/timetable/slots`,


    },
    registerlist: {
      root: `${ROOTS.DASHBOARD}/registerlist`,

      list: `${ROOTS.DASHBOARD}/registerlist/list`,

    },
    onlineenroll: {
      new: (id) => `${ROOTS.DASHBOARD}/onlineenroll/${id}/new`,
    },
    talent_hunt: {
      root: `${ROOTS.DASHBOARD}/talent-hunt/list`,
      list: `${ROOTS.DASHBOARD}/talent-hunt/list`,
      link_exams: `${ROOTS.DASHBOARD}/talent-hunt/link-exams`,
      admit_card_instructions: `${ROOTS.DASHBOARD}/talent-hunt/admit-card-instructions`,
      profile: (id) => `${ROOTS.DASHBOARD}/talent-hunt/${id}/profile`,
      analytics: (id) => `${ROOTS.DASHBOARD}/talent-hunt/${id}/analytics`,
      result: `${ROOTS.DASHBOARD}/talent-hunt/result`,
      students: `${ROOTS.DASHBOARD}/talent-hunt/students`,

      group: (id) => `${ROOTS.DASHBOARD}/talent-hunt/${id}/group`,
      groupstudent: (id) => `${ROOTS.DASHBOARD}/talent-hunt/${id}/groupstudent`,

    },
    height_student: {
      root: `${ROOTS.DASHBOARD}/height-student/list`,
      talent_hunt_exam: `${ROOTS.DASHBOARD}/height-student/talent-hunt-exam`,
      new: `${ROOTS.DASHBOARD}/height-student/new`,
      list: `${ROOTS.DASHBOARD}/height-student/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/height-student/${id}/edit`,
      profile: (id) => `${ROOTS.DASHBOARD}/height-student/${id}/profile`,
    },
    teacher: {
      root: `${ROOTS.DASHBOARD}/teacher`,
      assign: `${ROOTS.DASHBOARD}/teacher/assign`,
      transfer: `${ROOTS.DASHBOARD}/teacher/transfer`,
      allocate: `${ROOTS.DASHBOARD}/teacher/allocate`,
      log: `${ROOTS.DASHBOARD}/teacher/log`,
      unallocate: `${ROOTS.DASHBOARD}/teacher/unallocate`,
      teacherallocate: (id) => `${ROOTS.DASHBOARD}/teacher/${id}/allocate`,
      batchview: (id) => `${ROOTS.DASHBOARD}/teacher/${id}/batch`,
      batchsubject: (id) => `${ROOTS.DASHBOARD}/teacher/${id}/batchsubject`,
      courseubject: (id) => `${ROOTS.DASHBOARD}/teacher/${id}/subject`,
    },
    batch: {
      root: `${ROOTS.DASHBOARD}/batch`,
      new: `${ROOTS.DASHBOARD}/batch/new`,
      list: `${ROOTS.DASHBOARD}/batch/list`,
      logs: `${ROOTS.DASHBOARD}/batch/logs`,
      cards: `${ROOTS.DASHBOARD}/batch/cards`,
      profile: (id) => `${ROOTS.DASHBOARD}/batch/${id}/profile`,
      account: `${ROOTS.DASHBOARD}/batch/account`,
      view: `${ROOTS.DASHBOARD}/batch/view`,
      edit: (id) => `${ROOTS.DASHBOARD}/batch/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/batch/${MOCK_ID}/edit`,
      },
    },
    building: {
      root: `${ROOTS.DASHBOARD}/building/list`,
      new: `${ROOTS.DASHBOARD}/building/new`,
      allocation: `${ROOTS.DASHBOARD}/hostel/allocation`,
      list: `${ROOTS.DASHBOARD}/building/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/building/${id}/edit`,
      profile: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/profile`,
    },
    batchgroup: {
      root: `${ROOTS.DASHBOARD}/batchgroup`,
      new: `${ROOTS.DASHBOARD}/batchgroup/new`,
      list: `${ROOTS.DASHBOARD}/batchgroup/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/batchgroup/${id}/edit`,


    },
    heightexam: {
      root: `${ROOTS.DASHBOARD}/heightexam/list`,
      new: `${ROOTS.DASHBOARD}/heightexam/new`,
      list: `${ROOTS.DASHBOARD}/heightexam/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/heightexam/${id}/edit`,
      profile: (id) => `${ROOTS.DASHBOARD}/heightexam/${id}/profile`,

    },
    // teacher: {
    //   root: `${ROOTS.DASHBOARD}/teacher`,
    //   assign: `${ROOTS.DASHBOARD}/teacher/assign`,
    //   transfer: `${ROOTS.DASHBOARD}/teacher/transfer`,
    //   allocate: `${ROOTS.DASHBOARD}/teacher/allocate`,
    // },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    // courses: {
    //   root: `${ROOTS.DASHBOARD}/courses`,
    //   new: `${ROOTS.DASHBOARD}/courses/new`,
    //   // new: '/dashboard/courses/new',
    //   details: (id) => `${ROOTS.DASHBOARD}/courses/${id}`,
    //   edit: (id) => `${ROOTS.DASHBOARD}/courses/${id}/edit`,
    //   demo: {
    //     details: `${ROOTS.DASHBOARD}/courses/${MOCK_ID}`,
    //     edit: `${ROOTS.DASHBOARD}/courses/${MOCK_ID}/edit`,
    //   },
    // },
    courses: {
      root: `${ROOTS.DASHBOARD}/courses/list`,
      new: `${ROOTS.DASHBOARD}/courses/new`,
      list: `${ROOTS.DASHBOARD}/courses/list`,
      logs: `${ROOTS.DASHBOARD}/courses/logs`,
      cards: `${ROOTS.DASHBOARD}/courses/cards`,
      profile: (id) => `${ROOTS.DASHBOARD}/courses/${id}/profile`,
      account: `${ROOTS.DASHBOARD}/courses/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/courses/${id}/edit`,
      configure: `${ROOTS.DASHBOARD}/courses/configure`,
      material: `${ROOTS.DASHBOARD}/courses/material`,
      online: (id) => `${ROOTS.DASHBOARD}/courses/${id}/online`,
      offline: (id) => `${ROOTS.DASHBOARD}/courses/${id}/offline`,
      hybrid: (id) => `${ROOTS.DASHBOARD}/courses/${id}/hybrid`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/courses/${MOCK_ID}/edit`,
      },
    },
    courseGroup: {
      root: `${ROOTS.DASHBOARD}/courses/group/list`,
      coursegroupprofile: (id) => `${ROOTS.DASHBOARD}/courses/group/${id}/profile`,
    },
    lms: {
      root: `${ROOTS.DASHBOARD}/lms`,
    },
    studentprofile: {
      root: `${ROOTS.DASHBOARD}/studentprofile`,
    },
    studentexamination: {
      root: `${ROOTS.DASHBOARD}/studentexamination`,
    },
    schedule: {
      root: `${ROOTS.DASHBOARD}/schedule`,
    },
    examinationresult: {
      root: `${ROOTS.DASHBOARD}/examinationresult`,
      profile: (id) => `${ROOTS.DASHBOARD}/examinationresult/${id}/profile`,

    },
    mylearning: {
      root: `${ROOTS.DASHBOARD}/mylearning`,
      player: `${ROOTS.DASHBOARD}/mylearning/player`,
      courses: `${ROOTS.DASHBOARD}/mylearning/courses-view`,
    },
    cashregister: {
      root: `${ROOTS.DASHBOARD}/cashregister`,
      openview: `${ROOTS.DASHBOARD}/cashregister/openview`,
      closeview: `${ROOTS.DASHBOARD}/cashregister/closeview`,
      reconciliation: `${ROOTS.DASHBOARD}/cashregister/reconciliation`,
      logs: `${ROOTS.DASHBOARD}/cashregister/logs`,
      approvals: `${ROOTS.DASHBOARD}/cashregister/approvals`,
      requests: `${ROOTS.DASHBOARD}/cashregister/requests`,
    },
    fee: {
      root: `${ROOTS.DASHBOARD}/fee/list`,
      new: `${ROOTS.DASHBOARD}/fee/new`,
      list: `${ROOTS.DASHBOARD}/fee/list`,
      cards: `${ROOTS.DASHBOARD}/fee/cards`,
      profile: `${ROOTS.DASHBOARD}/fee/profile`,
      edit: (id) => `${ROOTS.DASHBOARD}/fee/${id}/edit`,
      collect: (id) => `${ROOTS.DASHBOARD}/fee/${id}/collect`,

      demo: {
        edit: `${ROOTS.DASHBOARD}/fee/${MOCK_ID}/edit`,
      },
    },
    chequeapproval: {
      root: `${ROOTS.DASHBOARD}/chequeapproval/list`,
      list: `${ROOTS.DASHBOARD}/chequeapproval/list`,
    },
    refund: {
      root: `${ROOTS.DASHBOARD}/refund/list`,
      new: `${ROOTS.DASHBOARD}/refund/new`,
    },
    examination: {
      root: `${ROOTS.DASHBOARD}/examination/list`,
      new: `${ROOTS.DASHBOARD}/examination/new`,
      log: `${ROOTS.DASHBOARD}/examination/log`,
      list: `${ROOTS.DASHBOARD}/examination/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/examination/${id}/edit`,
      profile: (id) => `${ROOTS.DASHBOARD}/examination/${id}/profile`,
      rank: (id) => `${ROOTS.DASHBOARD}/examination/${id}/rank`,

    },
    pattern: {
      root: `${ROOTS.DASHBOARD}/pattern/list`,
      new: `${ROOTS.DASHBOARD}/pattern/new`,
      list: `${ROOTS.DASHBOARD}/pattern/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/pattern/${id}/edit`,
      duplicate: (id) => `${ROOTS.DASHBOARD}/pattern/${id}/duplicate`,
    },
    attendanceadmin: {
      root: `${ROOTS.DASHBOARD}/attendanceadmin/list`,
      new: `${ROOTS.DASHBOARD}/attendanceadmin/new`,
      list: `${ROOTS.DASHBOARD}/attendanceadmin/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/attendanceadmin/${id}/edit`,
    },
    allpayments: {
      root: `${ROOTS.DASHBOARD}/allpayments/list`,
      list: `${ROOTS.DASHBOARD}/allpayments/list`,
    },
    offlineexam: {
      root: `${ROOTS.DASHBOARD}/offlineexam/list`,
      new: `${ROOTS.DASHBOARD}/offlineexam/new`,
      list: `${ROOTS.DASHBOARD}/offlineexam/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/offlineexam/${id}/edit`,
    },
    register: {
      root: `${ROOTS.DASHBOARD}/register`,
      profile: (id) => `${ROOTS.DASHBOARD}/register/${id}/profile`,
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },

    questionbank: {
      root: `${ROOTS.DASHBOARD}/questionbank/list`,
      logs: `${ROOTS.DASHBOARD}/questionbank/logs`,
      new: `${ROOTS.DASHBOARD}/questionbank/new`,
      list: `${ROOTS.DASHBOARD}/questionbank/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/questionbank/${id}/edit`,
      profile: (id) => `${ROOTS.DASHBOARD}/questionbank/${id}/profile`,
      allocation: (id) => `${ROOTS.DASHBOARD}/questionbank/${id}/allocation`,
    },
    permission_configure: {
      root: `${ROOTS.DASHBOARD}/permissions-configure`,
    },
    qr: {
      list: `${ROOTS.DASHBOARD}/qr/`,
    },
    hostel: {
      root: `${ROOTS.DASHBOARD}/hostel/list`,
      new: `${ROOTS.DASHBOARD}/hostel/new`,
      logs: `${ROOTS.DASHBOARD}/hostel/logs`,
      hostellogs: `${ROOTS.DASHBOARD}/hostel/hostellogs`,
      wardenlogs: `${ROOTS.DASHBOARD}/hostel/wardenlogs`,
      allocation: `${ROOTS.DASHBOARD}/hostel/allocation`,
      roomlist: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/roomlist`,
      allocationlist: `${ROOTS.DASHBOARD}/hostel/allocation/list`,
      vacatedbedlist: `${ROOTS.DASHBOARD}/hostel/vacated-beds`,
      list: `${ROOTS.DASHBOARD}/hostel/list`,
      vacate_refund_list: `${ROOTS.DASHBOARD}/hostel/vacate-refund`,
      campuslist: `${ROOTS.DASHBOARD}/hostel/campuslist`,
      hostel_text: `${ROOTS.DASHBOARD}/hostel/hostel-text`,
      collect: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/collect`,
      // collect: `${ROOTS.DASHBOARD}/hostel/collect`,
      edit: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/edit`,
      allocationedit: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/allocationedit`,
      profile: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/profile`,
      allocationdetail: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/allocation`,
      allocationoutsiderdetail: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/allocation/outsider`,
      agreement: (id) => `${ROOTS.DASHBOARD}/hostel/${id}/agreement`,
    },
    outsider: {
      root: `${ROOTS.DASHBOARD}/outsider/list`,
      new: `${ROOTS.DASHBOARD}/outsider/new`,
      logs: `${ROOTS.DASHBOARD}/outsider/logs`,
      list: `${ROOTS.DASHBOARD}/outsider/list`,
      profile: (id) => `${ROOTS.DASHBOARD}/outsider/${id}/profile`,
      edit: (id) => `${ROOTS.DASHBOARD}/outsider/${id}/edit`,
    },
    task: {
      list: `${ROOTS.DASHBOARD}/task/list`,
    },
    report: {
      list: `${ROOTS.DASHBOARD}/report`,
    },
    studentbalancereport: {
      list: `${ROOTS.DASHBOARD}/studentbalancereport`,
    },
    hostel_mess_balance_report: {
      list: `${ROOTS.DASHBOARD}/hostel-mess-balance-report`,
    },
    addmissionsummary: {
      list: `${ROOTS.DASHBOARD}/addmissionsummary`,
    },
    batchtopper: {
      list: `${ROOTS.DASHBOARD}/batchtopper`,
    },
    testresultreport: {
      list: `${ROOTS.DASHBOARD}/testresultreport`,
    },
    quizsubjectmarksreport: {
      list: `${ROOTS.DASHBOARD}/quizsubjectmarksreport`,
    },
    queswiseanalysis: {
      list: `${ROOTS.DASHBOARD}/queswiseanalysis`,
    },
    studenttestanalysis: {
      list: `${ROOTS.DASHBOARD}/studenttestanalysis`,
    },
    studentqueswiseanalysis: {
      list: `${ROOTS.DASHBOARD}/studentqueswiseanalysis`,
    },
    studentreportcard: {
      list: `${ROOTS.DASHBOARD}/studentreportcard`,
    },
    gstreport: {
      root: `${ROOTS.DASHBOARD}/gstreport`,
      list: `${ROOTS.DASHBOARD}/gstreport`,
    },
    dailycollectionreport: {
      root: `${ROOTS.DASHBOARD}/dailycollectionreport`,
      list: `${ROOTS.DASHBOARD}/dailycollectionreport`,
    },
    syllabus: {
      root: `${ROOTS.DASHBOARD}/syllabus/list`,
      new: `${ROOTS.DASHBOARD}/syllabus/new`,
      logs: `${ROOTS.DASHBOARD}/syllabus/logs`,
      list: `${ROOTS.DASHBOARD}/syllabus/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/syllabus/${id}/edit`,
      profile: (id) => `${ROOTS.DASHBOARD}/syllabus/${id}/profile`,
    },

    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
  },

  academicdashboard: {
    root: ROOTS.ACADEMICDASHBOARD,

    permission: `${ROOTS.ACADEMICDASHBOARD}/permission`,

    general: {
      app: `${ROOTS.ACADEMICDASHBOARD}/app`,

    },

    examinationresult: {
      root: `${ROOTS.ACADEMICDASHBOARD}/examinationresult`,
      profile: (id) => `${ROOTS.ACADEMICDASHBOARD}/examinationresult/${id}/profile`,

    },

    examination: {
      root: `${ROOTS.ACADEMICDASHBOARD}/examination/list`,
      new: `${ROOTS.ACADEMICDASHBOARD}/examination/new`,
      log: `${ROOTS.ACADEMICDASHBOARD}/examination/log`,
      list: `${ROOTS.ACADEMICDASHBOARD}/examination/list`,
      edit: (id) => `${ROOTS.ACADEMICDASHBOARD}/examination/${id}/edit`,
      profile: (id) => `${ROOTS.ACADEMICDASHBOARD}/examination/${id}/profile`,

    },
    pattern: {
      root: `${ROOTS.ACADEMICDASHBOARD}/pattern/list`,
      new: `${ROOTS.ACADEMICDASHBOARD}/pattern/new`,
      list: `${ROOTS.ACADEMICDASHBOARD}/pattern/list`,
      edit: (id) => `${ROOTS.ACADEMICDASHBOARD}/pattern/${id}/edit`,
      duplicate: (id) => `${ROOTS.ACADEMICDASHBOARD}/pattern/${id}/duplicate`,
    },

    offlineexam: {
      root: `${ROOTS.ACADEMICDASHBOARD}/offlineexam/list`,
      new: `${ROOTS.ACADEMICDASHBOARD}/offlineexam/new`,
      list: `${ROOTS.ACADEMICDASHBOARD}/offlineexam/list`,
      edit: (id) => `${ROOTS.ACADEMICDASHBOARD}/offlineexam/${id}/edit`,
    },


    questionbank: {
      root: `${ROOTS.ACADEMICDASHBOARD}/questionbank/list`,
      new: `${ROOTS.ACADEMICDASHBOARD}/questionbank/new`,
      list: `${ROOTS.ACADEMICDASHBOARD}/questionbank/list`,
      edit: (id) => `${ROOTS.ACADEMICDASHBOARD}/questionbank/${id}/edit`,
      profile: (id) => `${ROOTS.ACADEMICDASHBOARD}/questionbank/${id}/profile`,
      allocation: (id) => `${ROOTS.ACADEMICDASHBOARD}/questionbank/${id}/allocation`,
    },
    assignment: {
      root: `${ROOTS.ACADEMICDASHBOARD}/assignment/list`,
      list: `${ROOTS.ACADEMICDASHBOARD}/assignment/list`,
      allocated: (id) => `${ROOTS.ACADEMICDASHBOARD}/assignment/${id}/allocated`,
      completed: (id) => `${ROOTS.ACADEMICDASHBOARD}/assignment/${id}/completed`,

    },
    teachertimetable: {
      root: `${ROOTS.ACADEMICDASHBOARD}/teachertimetable/list`,
      list: `${ROOTS.ACADEMICDASHBOARD}/teachertimetable/list`,

    },


    task: {
      list: `${ROOTS.ACADEMICDASHBOARD}/task/list`,
    },


    batchtopper: {
      list: `${ROOTS.ACADEMICDASHBOARD}/batchtopper`,
    },
    testresultreport: {
      list: `${ROOTS.ACADEMICDASHBOARD}/testresultreport`,
    },
    quizsubjectmarksreport: {
      list: `${ROOTS.ACADEMICDASHBOARD}/quizsubjectmarksreport`,
    },
    queswiseanalysis: {
      list: `${ROOTS.ACADEMICDASHBOARD}/queswiseanalysis`,
    },
    studenttestanalysis: {
      list: `${ROOTS.ACADEMICDASHBOARD}/studenttestanalysis`,
    },
    studentqueswiseanalysis: {
      list: `${ROOTS.ACADEMICDASHBOARD}/studentqueswiseanalysis`,
    },
    studentreportcard: {
      list: `${ROOTS.ACADEMICDASHBOARD}/studentreportcard`,
    },
    syllabus: {
      root: `${ROOTS.ACADEMICDASHBOARD}/syllabus/list`,
      new: `${ROOTS.ACADEMICDASHBOARD}/syllabus/new`,
      logs: `${ROOTS.ACADEMICDASHBOARD}/syllabus/logs`,
      list: `${ROOTS.ACADEMICDASHBOARD}/syllabus/list`,
      edit: (id) => `${ROOTS.ACADEMICDASHBOARD}/syllabus/${id}/edit`,
      profile: (id) => `${ROOTS.ACADEMICDASHBOARD}/syllabus/${id}/profile`,
    },
  },

  // STUDENT DASHBOARD
  studentdashboard: {
    reattempt: `${ROOTS.STUDENTDASHBOARD}/reattempt`,
    root: ROOTS.STUDENTDASHBOARD,
    studymaterial: `${ROOTS.STUDENTDASHBOARD}/study-material`,
    attendance: `${ROOTS.STUDENTDASHBOARD}/attendance`,
    fee_student: `${ROOTS.STUDENTDASHBOARD}/feestudent`,
    feestudentcollect: `${ROOTS.STUDENTDASHBOARD}/feestudentcollect`,
    payfee: `${ROOTS.STUDENTDASHBOARD}/payfee`,
    lms: {
      root: `${ROOTS.STUDENTDASHBOARD}/lms`,
    },
    studentprofile: {
      root: `${ROOTS.STUDENTDASHBOARD}/studentprofile`,
    },
    studentexamination: {
      root: `${ROOTS.STUDENTDASHBOARD}/studentexamination`,
    },
    schedule: {
      root: `${ROOTS.STUDENTDASHBOARD}/schedule`,
    },
    examinationresult: {
      root: `${ROOTS.STUDENTDASHBOARD}/examinationresult`,
      profile: (id) => `${ROOTS.STUDENTDASHBOARD}/examinationresult/${id}/profile`,
    },
    mylearning: {
      root: `${ROOTS.STUDENTDASHBOARD}/mylearning`,
      player: `${ROOTS.STUDENTDASHBOARD}/mylearning/player`,
      courses: `${ROOTS.STUDENTDASHBOARD}/mylearning/courses-view`,
    },
    studenttimetable: {
      root: `${ROOTS.STUDENTDASHBOARD}/studenttimetable/list`,
      list: `${ROOTS.STUDENTDASHBOARD}/studenttimetable/list`,
    },
    feestudent: {
      collect: (id) => `${ROOTS.STUDENTDASHBOARD}/fee/${id}/collect`,
    },
    hostel: {
      collect: (id) => `${ROOTS.STUDENTDASHBOARD}/hostel/${id}/collect`,
    },
    mess: {
      collect: (id) => `${ROOTS.STUDENTDASHBOARD}/mess/${id}/collect`,
    },
    task: {
      list: `${ROOTS.STUDENTDASHBOARD}/task/list`,
    },
    report: {
      list: `${ROOTS.STUDENTDASHBOARD}/studentreportcard`,
    },
    studentreportcard: {
      list: `${ROOTS.STUDENTDASHBOARD}/studentreportcard`,
    },
    studenttestanalysis: {
      list: `${ROOTS.STUDENTDASHBOARD}/studenttestanalysis`,
    },
    studentqueswiseanalysis: {
      list: `${ROOTS.STUDENTDASHBOARD}/studentqueswiseanalysis`,
    },
    testresultreport: {
      list: `${ROOTS.STUDENTDASHBOARD}/testresultreport`,
    },
    queswiseanalysis: {
      list: `${ROOTS.STUDENTDASHBOARD}/queswiseanalysis`,
    },
    quizsubjectmarksreport: {
      list: `${ROOTS.STUDENTDASHBOARD}/quizsubjectmarksreport`,
    },
  },
  parentdashboard: {
    root: ROOTS.PARENTDASHBOARD,
    attendance: `${ROOTS.PARENTDASHBOARD}/attendance`,
    feeparent: `${ROOTS.PARENTDASHBOARD}/feeparent`,
    payfee: `${ROOTS.PARENTDASHBOARD}/payfee`,
    testresults: `${ROOTS.PARENTDASHBOARD}/testresults`,
    examinationresult: {
      root: `${ROOTS.PARENTDASHBOARD}/examinationresult`,
      profile: (id) => `${ROOTS.PARENTDASHBOARD}/examinationresult/${id}/profile`,
    },
    feepay: (id) => `${ROOTS.STUDENTDASHBOARD}/feepay/${id}/`,
    task: {
      list: `${ROOTS.PARENTDASHBOARD}/task/list`,
    },
    report: {
      list: `${ROOTS.PARENTDASHBOARD}/studentreportcard`,
    },
    studentreportcard: {
      list: `${ROOTS.PARENTDASHBOARD}/studentreportcard`,
    },
    studenttestanalysis: {
      list: `${ROOTS.PARENTDASHBOARD}/studenttestanalysis`,
    },
    studentqueswiseanalysis: {
      list: `${ROOTS.PARENTDASHBOARD}/studentqueswiseanalysis`,
    },
    testresultreport: {
      list: `${ROOTS.PARENTDASHBOARD}/testresultreport`,
    },
    queswiseanalysis: {
      list: `${ROOTS.PARENTDASHBOARD}/queswiseanalysis`,
    },
    quizsubjectmarksreport: {
      list: `${ROOTS.PARENTDASHBOARD}/quizsubjectmarksreport`,
    },
  },
  // OUTSIDER DASHBOARD
  outsiderdashboard: {
    root: ROOTS.OUTSIDERDASHBOARD,
    fee: {
      root: `${ROOTS.OUTSIDERDASHBOARD}/fee/list`,
      collect: `${ROOTS.OUTSIDERDASHBOARD}/fee/collect`,
      allocationdetail: (id) => `${ROOTS.OUTSIDERDASHBOARD}/fee/${id}/allocation`,
    },
  },
  guestdashboard: {
    root: ROOTS.GUESTDASHBOARD,
  },
};
